import { ChainType } from "types";

export const ecosystem: ChainType = process.env.REACT_APP_ECOSYSTEM?.toLocaleLowerCase() as ChainType;

const isMainnet = (): boolean => {
  return ecosystem === ChainType.Mainnet;
}

export default isMainnet;